<template>
  <div class="mb-5">
    <section-title :text="title"></section-title>
    <v-card class="mb-1" outlined>
      <v-data-table :headers="headers" :items="items" :mobile-breakpoint="0" v-model="selected" item-key="id"
        group-by="name" :hide-default-header="!isListView" hide-default-footer disable-pagination disable-sort>
        <template v-slot:[`group.header`]="{ group, headers }">
          <td :colspan="headers.length">
            <span style="font-weight:bold;" v-html="group"></span>
          </td>
        </template>

        <template v-if="viewType === 'card'" v-slot:item="{ item, isSelected, select } ">
          <tr :class="[{'v-data-table__selected': isSelected}]" @click="select(!isSelected)">
            <OrderCard :item="item" />
          </tr>
        </template>
        <template v-else v-slot:item="{ item, isSelected, select } ">
          <tr :class="[{'v-data-table__selected': isSelected}]" @click="select(!isSelected)">
            <td>
              <DeliveryStatus :status="item.status" />
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.item_name }}</td>
            <td>{{ `${item.count}&nbsp;本` }}</td>
            <td v-if="isAdmin">{{ item.area_name }}</td>
            <td v-if="isShippingDriver && type === 'from'">{{ item.area_name }}</td>
            <td v-if="(isShippingDriver && type === 'to')">{{ item.farm_name }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import SectionTitle from "@/components/driver/SectionTitle.vue";
import DeliveryStatus from "@/components/driver/information/DeliveryStatus.vue";
import OrderCard from "@/components/driver/information/OrderCard.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    SectionTitle,
    DeliveryStatus,
    OrderCard
  },
  props: {
    title: String,
    items: Array,
    type: String,
    isAdmin: Boolean,
    headers: Array,
    viewType: String
  },
  computed: {
    selected: {
      get() {
        return this.$store.state.driverInformation.selectedList.delivery[
          this.type
        ];
      },
      set(value) {
        console.log(value);
        const checkListType = this.type === "from" ? "to" : "from";
        if (
          this.$store.state.driverInformation.selectedList.delivery[
            checkListType
          ].length > 0
        ) {
          value = [];
        }
        const payload = {
          viewType: "delivery",
          listType: this.type,
          selected: value,
        };
        this.$store.dispatch("driverInformation/setSelected", payload);
      },
    },
    driverType() {
      return this.$store.state.user.driver && this.$store.state.user.driver.driver_type;
    },
    isShippingDriver() {
      return this.driverType === "shipping";
    },
    isDeliveryDriver() {
      return this.driverType === "delivery";
    },
    isListView() {
      return this.viewType === "list";
    }
  },
  methods: {
    formatDate(d) {
      return formatDate(d, "yyyy-mm-dd");
    }
  },
};
</script>

<style scoped>
.bb-none {
  border-bottom: none !important;
}

.v-data-table td {
  padding: 0 8px !important;
}
</style>
